// Chairs.js
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAllChairsByMap } from '../../../store/Chairs/ChairsThunk';
import Chair from './Chair';

const Chairs = ({ mapId,  avatarBounds, mapRef, clickable }) => {
  const dispatch = useDispatch();
  const { chairs, loading, error } = useSelector((state) => state.chairs);
  const overlays = useRef({}); 
  const clickableRef = useRef(clickable);

  useEffect(() => {
    // Grace period to give time for click events to finish
    const timeout = setTimeout(() => {
      clickableRef.current = clickable;
    }, 50);
  }, [clickable]);

  useEffect(() => {
    if (mapId) {
      dispatch(getAllChairsByMap({ params: [{ map_id: mapId }] }));
    }
  }, [mapId]);

  if (loading || !avatarBounds) return null;
  if (error) {
    console.error('Error loading chairs:', error);
    return null;
  }

  const validChairs = chairs.filter(chair => chair.lat != null && chair.lng != null);

  return (
    <>
      {validChairs.map((chair) => (
        <Chair
          key={chair.id}
          chair={chair}
          chairBounds={avatarBounds}
          mapRef={mapRef}
          overlays={overlays}
          clickableRef={clickableRef}
        />
      ))}
    </>
  );
};

export default Chairs;